import { gql } from '@apollo/client'
import { BaseBlock, BlockFragment } from '../blocks.types'

export const ShareLinkBlockFragment: BlockFragment = {
  name: 'shareLink',
  fragment: gql`
    fragment shareLink on ShareLink {
      id
      blockName
      blockType
      shareLinkHeading: heading
      buttonLabel
      copyLinkLabel
      shareLink
      shareLinkBackgroundColor: backgroundColor
      excludedPlatforms {
        ios
        android
        web
      }
    }
  `,
  partialFragment: `
    ...on ShareLink {
      id
      blockName
      blockType
      shareLinkHeading: heading
      buttonLabel
      copyLinkLabel
      shareLink
      shareLinkBackgroundColor: backgroundColor
      excludedPlatforms {
        ios
        android
        web
      }
    }
  `,
}

export const ShareLinkBlockType = 'shareLink'

export interface ShareLinkBlock extends BaseBlock {
  blockType: typeof ShareLinkBlockType
  shareLinkHeading: string
  buttonLabel: string
  copyLinkLabel: string
  shareLink: string
  shareLinkBackgroundColor?: string
}
